import {useEffect} from "react";
import defaultLogger from "../Logger";
import { AlmeEnvironmentConfig } from "../api/AlmeEnvironmentConfig";

export function useSetDefaultLoggingLevel(): void {
    const config = AlmeEnvironmentConfig.getInstance().getConfig();
    useEffect(() => {
        if (config && config.UiLogLevel && typeof config.UiLogLevel === 'string') {
            try {
                defaultLogger.loggingLevel = parseInt(config.UiLogLevel);
            } catch (ex) {
                // do nothing.
            }
        }
    }, [config]);
}
